import { useState, useEffect } from 'react'
import visaLogo from '../../assets/visa.png'
import masterLogo from '../../assets/mastercard-2.svg'
import amexLogo from '../../assets/American_Express.png'
import { countryList } from '../../data/countries'
import PaymentCard from './PaymentCard'
import { useCardContext } from '../../hooks/useCardContext'
import { useCountryContext } from '../../hooks/useCountryContext'
import AlertModal from '../../components/AlertModal'

export default function Dashboard() {
	const [cardNumber, setCardNumber] = useState()
	const [cvvNumber, setCvvNumber] = useState()
	const [cardHolder, setCardHolder] = useState()
	const [cardMonth, setCardMonth] = useState()
	const [cardYear, setCardYear] = useState()
	const [bankIcon, setBankIcon] = useState(null)
	const [selectedCountry, setSelectedCountry] = useState(null)
	const [error, setError] = useState(null)
	const [cvvError, setCvvError] = useState(null)
	const [globalError, setGlobalError] = useState(null)
	const [dateError, setDateError] = useState(null)
	const [disableBtn, setDisableBtn] = useState(true)
	const [isOpen, setIsOpen] = useState(false)
	const { dispatch, value } = useCardContext()
	const { countries } = useCountryContext()

	useEffect(() => {
		if (cardNumber) {
			setError(null)
			if (cardNumber.substring(0, 1) === '4') {
				setBankIcon(visaLogo)
			} else if (cardNumber.substring(0, 1) === '3') {
				setBankIcon(amexLogo)
			} else if (cardNumber.substring(0, 1) === '5') {
				setBankIcon(masterLogo)
			} else {
				setBankIcon(null)
				setError('Invalid card number')
			}
		}
	}, [cardNumber])

	useEffect(() => {
		if (
			cardNumber &&
			cvvNumber &&
			cardHolder &&
			cardMonth &&
			cardYear &&
			selectedCountry
		) {
			setDisableBtn(false)
		}
	}, [cardHolder, cardMonth, cardNumber, cardYear, cvvNumber, selectedCountry])

	// All validations are done manually no libraries used
	// The easier option would have been React-Hook-Form or Formik with Yup
	// using state for custom error messages

	const validateCardNumber = numValue => {
		setGlobalError(null)
		setError(null)
		;/^(?!\s)[0-9\s]+$/.test(numValue)
			? setCardNumber(numValue)
			: setError('Invalid card format')
	}

	const validateCvvNumber = numValue => {
		setGlobalError(null)
		setCvvError(null)
		;/^(?!\s)[0-9\s]+$/.test(numValue)
			? setCvvNumber(numValue)
			: setCvvError('Invalid format')
	}
	const validateMonth = numValue => {
		setGlobalError(null)
		setDateError(null)
		;/^(?!\s)[0-9\s]+$/.test(numValue)
			? setCardMonth(numValue)
			: setDateError('Invalid format')
	}
	const validateYear = numValue => {
		setGlobalError(null)
		setDateError(null)
		;/^(?!\s)[0-9\s]+$/.test(numValue)
			? setCardYear(numValue)
			: setDateError('Invalid format')
	}

	const handleSelectedCountry = e => {
		setGlobalError(null)
		if (e.target.value === '--Select--') return
		if (countries.includes(e.target.value)) {
			setGlobalError('The selected country is banned')
			return
		}
		setSelectedCountry(e.target.value)
	}

	const handleSubmit = e => {
		e.preventDefault()
		setGlobalError(null)
		if (error || cvvError || dateError) return
		if (!selectedCountry) {
			setGlobalError('Your must select a country')
			return
		}
		if (cardNumber.length < 15) {
			setGlobalError('Your card number is invalid')
			return
		}
		if (cvvNumber.length < 3) {
			setGlobalError('CVV number is invalid')
			return
		}
		if (cardYear.length < 4) {
			setGlobalError('Card year is invalid')
			return
		}
		if (cardYear.length < 4) {
			setGlobalError('Card year is invalid')
			return
		}
		if (cardMonth > 12 || cardMonth === 0) {
			setGlobalError('Card month is invalid')
			return
		}

		if (cardYear <= new Date().getFullYear()) {
			if (cardMonth < new Date().getMonth() + 1) {
				setGlobalError('This card has expired')
				return
			}
		}

		const existingCardNumber = value.find(
			card => card.cardNumber === cardNumber
		)
		if (existingCardNumber) {
			setGlobalError('This card has already been added')
			setDisableBtn(true)
			return
		}

		dispatch({
			type: 'ADD_CARD',
			payload: {
				country: selectedCountry,
				cardHolder: cardHolder,
				cardNumber: cardNumber,
				expiryMonth: cardMonth,
				expiryYear: cardYear,
			},
		})
		setIsOpen(true)
	}

	const handleFormReset = e => {
		e.preventDefault()
		setGlobalError(null)
		setDateError(null)
		setCvvError(null)
		setError(null)
		e.target.form.reset()
		setIsOpen(false)
	}

	return (
		<div className='flex'>
			<div className='flex items-center'>
				<div className='flex m-2 bg-white p-5 rounded-md shadow-md'>
					<form onSubmit={handleSubmit} className='flex flex-col'>
						{isOpen && <AlertModal handleFormReset={handleFormReset} />}
						<label>Card Holder</label>
						<span className='text-xs text-gray-400'>
							Insert name on the card
						</span>
						<input
							type='text'
							className='textfield'
							required
							maxLength={16}
							onChange={e => setCardHolder(e.target.value)}
						/>
						<label>Card Number</label>
						<span className='text-xs text-gray-400'>
							Insert a 16-digit number on the card
						</span>
						<input
							type='text'
							className={`textfield ${error && 'border-red-500'} `}
							maxLength={16}
							required
							onChange={e => validateCardNumber(e.target.value)}
						/>
						{error && <p className='text-xs text-red-500'>{error}</p>}
						<div className='flex justify-between w-80 my-2'>
							<div className='flex flex-col'>
								<label>CVV Number</label>
								<span className='text-xs text-gray-400'>
									Insert a 3-digit number{' '}
								</span>
								<input
									type='text'
									className={`textfield w-20 text-center ${
										cvvError && 'border-red-500'
									}`}
									placeholder='***'
									maxLength={3}
									required
									onChange={e => validateCvvNumber(e.target.value)}
								/>
								{cvvError && <p className='text-xs text-red-500'>{cvvError}</p>}
							</div>
							<div className='flex flex-col'>
								<label>Expiry Date</label>
								<span className='text-xs text-gray-400'>
									Insert a expiration date
								</span>
								<div className='flex items-center'>
									<input
										type='text'
										className={`textfield w-16 text-center ${
											dateError && 'border-red-500'
										} `}
										placeholder='MM'
										maxLength='2'
										required
										onChange={e => validateMonth(e.target.value)}
									/>
									<p className='mx-1'>/</p>
									<input
										type='text'
										className={`textfield w-16 text-center ${
											dateError && 'border-red-500'
										} `}
										placeholder='YYYY'
										maxLength={4}
										required
										onChange={e => validateYear(e.target.value)}
									/>
								</div>
								{dateError && (
									<p className='text-xs text-red-500'>{dateError}</p>
								)}
							</div>
						</div>
						<label>Country</label>
						<span className='text-xs text-gray-400'>
							Country from which this card is provided{' '}
						</span>
						<select
							onChange={handleSelectedCountry}
							required
							className='textfield'>
							{countryList.map(country => (
								<option key={country} value={country}>
									{country}
								</option>
							))}
						</select>

						{globalError && (
							<p className='self-center text-xs text-red-500'>{globalError}</p>
						)}
						<div className='flex max-w-fit self-center'>
							<button
								disabled={disableBtn}
								className={`submitBtn ${disableBtn && 'bg-gray-200'}`}>
								Submit
							</button>
							<button
								onClick={handleFormReset}
								className='underline ml-5 text-red-500'>
								Clear
							</button>
						</div>
					</form>
				</div>
				<PaymentCard
					cardNumber={cardNumber}
					cvvNumber={cvvNumber}
					cardHolder={cardHolder}
					cardMonth={cardMonth}
					cardYear={cardYear}
					bankIcon={bankIcon}
				/>
			</div>
		</div>
	)
}
